import React, { useState, useEffect } from "react"
import InputField from "../../../../components/InputField"
import Button from "../../../../components/Button"
import { useHistory } from "react-router"
import { addNewMasterServices, getCenterDetails, getConsultantServiceDetailsById } from "../../../../core/services/api"
import "../../CenterAdmin/AddNewReferral/AddNewReferral.scss"
import { useLocation } from "react-router-dom"
import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
//import "./CopyServices.scss"
import Select from "react-select"




function EditService() {
  const history = useHistory()
  const [isSubmit, setIsSubmit] = useState(false)
  const [resData, setResData] = useState<any>()
  const [formErrors, setFormErrors] = useState<any>()
  const location = useLocation()
  const [doctorReferralInfo, setDoctorReferralInfo] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  const [centerDetail, setCenterDetail] = useState<any>()
  const [centerId, setCenterId] = useState<any>(null)
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })

  const [serviceIdValues, setServiceIdValues] = useState<any>();
  const serviceId = location.state.idValue;
  useEffect(() => {

    //setRole(userDetail?.currentRole);
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })

    getConsultantServiceDetailsById(serviceId).then((res: any) => {
      console.log(res, "res")
      setServiceIdValues(res)
    }).catch((err: any) => {
      console.log(err, "err");
    })

  }, [])

  console.log(serviceIdValues, "serviceeIdValues");
  const [serviceInfo, setserviceInfo] = useState<any>({
    name: "",
    appointmentType: "",
    defaultPrice: "",
    sacNumber: "",
    price: "",
    discountType: "",
    discountNumber: ""
  })

  function onSubmit(e: any) {

    e.preventDefault()

    const data = {
      centerId: centerId,
      name: serviceInfo.name,
      sacNumber: serviceInfo.sacNumber,
      appointmentType: serviceInfo.appointmentType,
      defaultPrice: serviceInfo.defaultPrice,
      tax: taxDetailsInfo,
      taxApplicable: true,
      rates: [
        {
          categoryId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          price: serviceInfo.price,
          discountType: serviceInfo.discountType,
          discount: serviceInfo.discountNumber,
        },
      ],
    }
    addNewMasterServices(data)
      .then((data) => {
        setResData(data)
        toggleDisplayToast(true)
        history.push(`/Service`)
      })
      .catch((err: any) => {
        toggleDisplayToast({
          text: "err",
          type: "error",
        })
      })
  }
  const appointment = {
    appointmentType: [
      "OPD",
      "IPD",
      "HC",
    ],
    discountType: [
      'PERCENTAGE',
      'AMOUNT'
    ]
  }
  const appointments: any = appointment?.appointmentType.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const discountsDropdown: any = appointment.discountType?.map((ele: any) => {
    return { label: ele, value: ele }
  })


  // taxes add and delete
  const taxDetails = {
    name: "",
    percentage: ""
  }
  let [taxDetailsInfo, setTaxDetailsInfo] = useState([taxDetails])


  console.log(location.state.centerName, "given");
  return (
    <div className="add-new-referral-container">
      <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push('/Service')
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="add-new-text">Edit Services</div>

      </div>
      <div className="add-new-referral-details">
        <form>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Center Name:</label>
            </div>
            <div className="col-3">
              <div className="custom-react-select">
                <Select
                  className=""
                  name="center"
                  defaultValue={{
                    label: "",
                    value: ""
                  }}
                  value={{
                    label: location.state.centerName,
                    value: ""
                  }}
                  options={dropdownCenters}
                  isDisabled={true}
                  onChange={(evnt: any) => {
                    setCenterId(evnt?.value);
                    //setData({ ...data, securityDepositMode: evnt?.value })
                  }}
                  styles={customSelectStyles()}
                />
              </div>
            </div>
          </div>

          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Service Name:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Service Name"
                value={serviceInfo.name}
                handleChange={(e) =>
                  setserviceInfo({
                    ...serviceInfo,
                    name: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Appointment Type:</label>
            </div>
            <div className="col-3">
              <div className="custom-react-select">
                <Select
                  styles={customSelectStyles()}
                  className="select-payment"
                  name="modeOfPayment"
                  defaultValue={{
                    label: "OPD",
                    value: "OPD"
                  }}
                  options={appointments}
                  onChange={(evnt) => {
                    setserviceInfo({
                      ...serviceInfo,
                      appointmentType: evnt?.value,
                    })
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Default Price:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Default Price"
                value={serviceInfo.defaultPrice}
                handleChange={(e) =>
                  setserviceInfo({
                    ...serviceInfo,
                    defaultPrice: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">SAC Number:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="SAC number"
                value={serviceInfo.sacNumber}
                handleChange={(e) =>
                  setserviceInfo({
                    ...serviceInfo,
                    sacNumber: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Price:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Price"
                value={serviceInfo.price}
                handleChange={(e) =>
                  setserviceInfo({
                    ...serviceInfo,
                    price: e.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className="row nameDetails">
            <div className="col-3">
              <label className="textlabel">Discount Type:</label>
            </div>
            <div className="col-2">
              <div className="custom-react-select">
                <Select
                  styles={customSelectStyles()}
                  className="select-payment"
                  name="modeOfPayment"
                  defaultValue={{
                    label: "PECENTAGE",
                    value: "PERCENTAGE"
                  }}
                  options={discountsDropdown}
                  onChange={(evnt) => {
                    setserviceInfo({
                      ...serviceInfo,
                      discountType: evnt?.value,
                    })
                  }}
                />
              </div>

            </div>
            <div className="col-1"></div>
            <div className="col-2">
              <label className="textlabels"
              >Discount Number:</label>
            </div>
            <div className="col-2">
              <InputField
                placeholder="Discount Number"
                value={serviceInfo.discountNumber}
                handleChange={(e) =>
                  setserviceInfo({
                    ...serviceInfo,
                    discountNumber: e.target.value,
                  })
                }
              />
            </div>
          </div>


          {taxDetailsInfo?.map((e, index) => {
            return (
              <div className="bed-details-container">
                <div className="row nameDetails">
                  <div className="col-3">
                    <label className="textlabel">Tax Name:</label>
                  </div>
                  <div className="col-2">
                    <InputField
                      placeholder="Tax Name"
                      value={taxDetailsInfo[index].name}
                      handleChange={(e) => {
                        const values = [...taxDetailsInfo]
                        values[index].name = e.target.value
                        setTaxDetailsInfo([...values])
                      }}
                    />
                  </div>
                  <div className="col-1"></div>
                  <div className="col-2">
                    <label className="textlabels"
                    >Tax Percentage:</label>
                  </div>
                  <div className="col-2">
                    <InputField
                      placeholder="Tax Percentage"
                      value={taxDetailsInfo[index].percentage}
                      handleChange={(e) => {
                        const values = [...taxDetailsInfo]
                        values[index].percentage = (e.target.value)
                        setTaxDetailsInfo([...values])
                      }}
                    />
                  </div>

                  <div className="col-1">
                    <div
                      className="delete-icon"
                      onClick={() => {
                        if (taxDetailsInfo.length > 1) {
                          const values = [...taxDetailsInfo]
                          values.splice(index, 1)
                          setTaxDetailsInfo(values)
                        }
                      }}
                    >
                      <img
                        src="../../../../assets/images/delete-icon.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            )
          })}

          <div className="add-new-bed-container">
            <div
              style={{}}
              className="add-new-button"
              onClick={() => setTaxDetailsInfo([...taxDetailsInfo, taxDetails])}
            >
              Add New Tax
            </div>
          </div>

          <div className="buttonalignment">
            <Button text="Save" onClick={(e: any) => onSubmit(e)} id="add-new-service-save" />
          </div>
        </form>

      </div>

    </div >
  )
}
export default EditService
